import { jsx as _jsx } from "react/jsx-runtime";
import InputAdornment from '@mui/material/InputAdornment';
import { Text } from '@famly/mf_data-display_text';
export const TextAdornment = ({ position, text, size }) => {
    return (_jsx(InputAdornment, { position: position, children: _jsx(Text, { variant: size === 'regular' ? 'body' : 'body-small', children: text }) }));
};
